import { updateObject } from '../utils/utility';
import { FUNCTION } from '../constants';

const initialState = {
    isLoading: true,
	isFail: true,
    isSuccess: false,
    result: {
        pagination: {
            totlal: 0,
            pageSize: 10,
            pageNumber: 1
        },
        resultList: []
    }
}

const functionReducer = (state = initialState, action) => {
    switch(action.type) {
        case FUNCTION.FUNCTION_QUERY: return queryFunction(state, action);
        case FUNCTION.FUNCTION_QUERY_SUCCESS: return queryFunctionSuccess(state, action);
        case FUNCTION.FUNCTION_QUERY_LOAD: return queryFunctionLoad(state, action);
        
        default: return state;
    }
}

const queryFunctionLoad = (state, action) => {
    return updateObject(state, {isLoading: true, isFail: false, isSuccess: false});
}

const queryFunction = (state, action) => {
    return updateObject(state, {isLoading: true});
}

const queryFunctionSuccess = (state, action) => {
    return updateObject(state, {
        isLoading: false,
        isFail: false,
        isSuccess: true,
        result: action.result
    });
}

export default functionReducer;